var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.273,
    height: 124.728,
    viewBox: "0 0 169.273 124.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.409,9H4.5V26.818H111.409Zm0,35.636H4.5V62.455H111.409ZM4.5,98.091H75.773V80.273H4.5ZM129.227,9V81.877A26.683,26.683,0,1,0,147.046,107V26.818h26.727V9Z",
    transform: "translate(-4.5 -9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/icon-music.afb7e266213f358df3d1a119fe8c205a.svg";
export { ForwardRef as ReactComponent };